import styles from "../components/bussiness-tabs/bussiness.module.css";
import Bussiness from "components/bussiness-tabs/Bussiness";
import { AiOutlinePlus } from "react-icons/ai";
import { MdOutlineCategory } from "react-icons/md";
import "./cstyle.css";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import LineModal from "components/bussiness-tabs/modal/LineModal";
import ManagementSidebar from "components/common/ManagementSidebar";
const BussinessPage = ({ accessLevel }) => {
  return (
    <>
      <div className=" w-100 mt-2 d-flex">
        {/* <ManagementSidebar></ManagementSidebar> */}
        <div className="container">
          <div className="d-flex mx-3 justify-content-end">
            {accessLevel.includes(104) && (
              <button
                className={`btn  mx-1 mt-3 ${styles.btnHov}`}
                id=""
                style={{ background: "#CCEEF0", border: "#5EAAB7 1px solid " }}
                data-bs-toggle="modal"
                data-bs-target="#exampleModalAdd"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <AiOutlinePlus />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    افزودن کسب و کار
                  </p>
                </div>
              </button>
            )}
            {accessLevel.includes(105) && (
              <button
                className={`btn  mx-1 mt-3 ${styles.btnHov2}`}
                id=""
                style={{
                  background: "rgb(246 204 79)",
                  border: "1px solid rgb(241 130 63)",
                }}
                data-bs-toggle="modal"
                data-bs-target="#LineModal"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <MdOutlineCategory />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    مدیریت لاین ها
                  </p>
                </div>
              </button>
            )}
            {/* <button className="btn btn-danger mx-1 mt-3" id="">
              <div className="d-flex justify-content-around align-items-center text-center">
                <FaTrashAlt />
                <p
                  className="textPro"
                  style={{ marginBottom: "0px", marginRight: "3px" }}
                >
                  {" "}
                  حذف فیلتر
                </p>
              </div>
            </button> */}
            {accessLevel.includes(104) && (
              <button
                className={`btn text-white  mx-1 mt-3 ${styles.btnHov3}`}
                id=""
                style={{ background: "#1A3764" }}
                data-bs-toggle="modal"
                data-bs-target="#filterModal"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <FaFilter />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    فیلتر
                  </p>
                </div>
              </button>
            )}
            <LineModal />
          </div>
          {accessLevel.includes(104) && <Bussiness />}
        </div>
      </div>
    </>
  );
};

export default BussinessPage;
